import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Faktureres månedligt. Årlig er en bindingsperiode, ikke en faktureringshyppighed.',
      options: {
        [SubscriptionTerm.Monthly]: 'Månedlig binding',
        [SubscriptionTerm.Annual]: 'Årlig binding',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Prismodel',
          title: 'Succesbaseret prisskala',
        },
        [PlanTab.legacy]: {
          name: 'Ældre',
          title: 'Abonnementer',
        },
      },
    },
    add_ons: {
      title: 'Bliv Pro med vores tilvalg til din Essential-plan',
      description: 'Tiltræk nye gæster og få flere gengangere med disse softwareløsninger.',
    },
  },
  labels: {
    recommended: 'Anbefalet',
    basket: 'Kurv: <strong>{{amount}}</strong> pr. måned',
  },
  buttons: {
    review_and_subscribe: 'Gennemse og abonnér',
    cancel: 'Annullér',
    basket: 'Tilbage til kurven',
    subscribe: 'Abonnér',
    update_subscription: 'Opdatér abonnement',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_save_contract: 'Serviceaftalen kunne ikke gemmes',
    failed_to_create_subscription: 'Abonnementet kunne ikke oprettes',
    subscription_created: 'Abonnementet er oprettet',
    subscription_updated: 'Abonnementet er opdateret',
  },
};
